import React from 'react';
import { CITY_TIERS } from '../constants/otrEnums';

export const CityTierTabs = ({ activeTier, onTierChange, isReadOnly = false }) => {
  const tiers = [
    { id: CITY_TIERS.TIER_1, label: 'Tier 1 Cities' },
    { id: CITY_TIERS.TIER_2, label: 'Tier 2 Cities' },
    { id: CITY_TIERS.TIER_3, label: 'Tier 3 Cities' },
  ];

  return (
    <div className="flex p-1 bg-[var(--color-workspace)] rounded-2xl border border-[var(--color-border)] mb-6">
      {tiers.map((tier) => (
        <button
          key={tier.id}
          onClick={() => !isReadOnly && onTierChange(tier.id)}
          disabled={isReadOnly && activeTier !== tier.id}
          className={`flex-1 h-10 text-[13px] font-bold rounded-xl transition-all ${
            activeTier === tier.id
              ? 'bg-white text-[var(--color-primary)] shadow-sm border border-[var(--color-border)]/50'
              : 'text-[var(--color-text-secondary)] hover:text-foreground'
          } ${isReadOnly && activeTier !== tier.id ? 'opacity-40 grayscale' : ''}`}
        >
          {tier.label}
        </button>
      ))}
    </div>
  );
};
